<div class="w-full relative">

  <img src="/background-header.jpg" alt="Sextou" class="w-full h-[70px] sm:h-[100px] object-cover" />
  <div class="absolute inset-0 bg-black/70"></div>

  <button class="absolute left-3 sm:left-10 lg:left-20 top-1/2 -translate-y-1/2 bg-transparent p-0">
    <img
      src="/redal_logo.png"
      alt="Redal Logo"
      class="h-[55px] w-auto sm:h-[80px] lg:h-[90px]"
      (click)="goToControl()"
    />
  </button>

  @if (isControlRoute()) {
    <!-- botão menu / fechar -->
    <button
      (click)="toggleMenu()"
      class="absolute right-3 sm:right-4 top-1/2 -translate-y-1/2 focus:outline-none"
    >
      @if (!menuOpen) {
        <svg class="w-7 h-7 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" stroke-width="2"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
      }
      @if (menuOpen) {
        <svg class="w-7 h-7 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" stroke-width="2"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      }
    </button>

    <!-- dropdown -->
    <div *ngIf="menuOpen" class="absolute right-3 sm:right-4 top-[58px] sm:top-16 bg-white shadow-lg rounded-md p-4 flex flex-col gap-2 z-[9999] min-w-[160px]">
      <button type="button"
              class="text-black w-full rounded-xl font-bold hover:bg-[#c70020] transition py-2 hover:text-white"
              (click)="goToUserProfile()">
        Meu perfil
      </button>

      <button type="button"
              class="text-black w-full rounded-xl font-bold hover:bg-[#c70020] transition py-2 hover:text-white"
              (click)="goToControl()">
        Painel de controle
      </button>

      <button type="button"
              class="text-black w-full rounded-xl font-bold hover:bg-[#c70020] transition py-2 hover:text-white"
              (click)="goToMembers()">
        Membros
      </button>

      <button type="button"
              class="text-black w-full rounded-xl font-bold hover:bg-[#c70020] transition py-2 hover:text-white"
              (click)="logout()">
        Sair
      </button>
    </div>
  }
</div>
